import { Component, TemplateRef, inject } from '@angular/core';
import { GigyaService } from './services/gigya/gigya.service';
import { AuthService } from './services/gigya/auth.service';
import { MenuService } from './services/menu.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslationsService } from './services/translations/translations.service';
import { TutorService } from './services/tutor/tutor.service';
import { DeviceService } from './services/device/device.service';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { listCountriesForFooter } from './utility/lists/lists';
import { lang } from './types/lists-type';
import { TranslationPipe } from './pipes/translation.pipe';
import { CookiebotService } from './services/cookiebot/cookiebot.service';



export interface Langs{
  value: string,
  valueView: string
}
declare let Cookiebot: any

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  private offcanvasService = inject(NgbOffcanvas);
  title = 'panini-fe-tutor';
  userLogged: boolean = false;
  isMobile: boolean = false;
  nameUser: string ="";
  lang: string = "";
  photo: string ="";
  language: string ="";
  statusAlert: any[] =[];
  langsDisabled: string[] = ["ko","id"];
  listOfLanguages: Langs[]=[
    {value:"br", valueView:"option.lang.br"},
    {value:"cs", valueView:"option.lang.cs"},
    {value:"da", valueView:"option.lang.da"},
    {value:"de", valueView:"option.lang.de"},
    {value:"el", valueView:"option.lang.el"},
    {value:"en", valueView:"option.lang.en"},
    {value:"es", valueView:"option.lang.es"},
    {value:"fi", valueView:"option.lang.fi"},
    {value:"fr", valueView:"option.lang.fr"},
    {value:"hu", valueView:"option.lang.hu"},
    {value:"it", valueView:"option.lang.it"},
    {value:"nl", valueView:"option.lang.nl"},
    {value:"no", valueView:"option.lang.no"},
    {value:"pl", valueView:"option.lang.pl"},
    {value:"pt", valueView:"option.lang.pt"},
    {value:"ro", valueView:"option.lang.ro"},
    {value:"sk", valueView:"option.lang.sk"},
    {value:"sv", valueView:"option.lang.sv"},
    {value:"tr", valueView:"option.lang.tr"}

  ];
  langFooter: string="";
  counterPending: number = 0;
  counterAnactive: number = 0;
  counterActive: number = 0;
  constructor(private gigya: GigyaService,
     private auth: AuthService,
     private menu: MenuService,    
     private router:   Router,
     private activeRoute: ActivatedRoute,    
     private trans: TranslationsService,
     public tutorService: TutorService,
     public deviceService : DeviceService,
     public cookieService: CookiebotService, 
     public transPipe: TranslationPipe
    ) {
      this.trans.lang.subscribe((lg)=>{
        this.lang=lg as string;
        this.langFooter = listCountriesForFooter[(this.lang == "pt-br"?"br":this.lang) as lang]
        this.language = "option.lang."+(lg== "pt-br"?"br":lg);
        this.cookieService.eventOnDialogInit(this.lang);
        if(this.langsDisabled.includes(lg as string)){
          this.changeLanguage("en");
        }
      });
    this.auth.loggedIn$.subscribe((lg: any) => {
      if (lg.logged) {
        this.nameUser = lg.userLogged?.profile?.firstName;
        this.userLogged = true;
        this.photo = lg.userLogged?.profile?.photoURL ?? "https://console.gigya.com/console-apps/ida-app/dist/assets/default-profile-picture.png";
      }else{
        this.userLogged = false;
      }
    });
    this.isMobile = this.deviceService.isMobile();



  }

  ngAfterViewInit(){
    this.gigya.loadCDC();
    
    this.trans.isTranslationAvaible$.subscribe((av)=>{
      if(av){
        this.listOfLanguages.sort((a, b) => {
          if (this.transPipe.transform(a.valueView) > this.transPipe.transform(b.valueView) ) {
            return 1;
          }
          if (this.transPipe.transform(a.valueView) < this.transPipe.transform(b.valueView)) {
            return -1;
          }
          return 0;
        });
      }

    });
  }
	openNoBackdrop(content: TemplateRef<any>) {
		this.offcanvasService.open(content, { backdrop: false });
	}
  logout(){
    this.gigya.logout();
  }
  showMyProfile(){
    this.menu.setMenu(false,true)
  }
  showMinorsProfile(){
    this.menu.setMenu(true,false)
  }
  cookiebotRenew() {
    Cookiebot.renew();
  }
  changeLanguage(lang:string){
    this.activeRoute.queryParams.subscribe(params => {
      this.router.navigate([lang == "br"? "pt-br":lang, 'home'],
      { queryParams: { UID: params['UID'], country:  params['country']},   onSameUrlNavigation: 'reload'  },).then(()=>{ location.reload()});
    });
  }


}
